export default {"src":"/_next/static/media/residential4.47443eac.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};